<template>
  <v-col>
    <v-card>
      <v-spacer></v-spacer>
      <v-tabs v-model="tab" align-with-title>
        <v-tab href="#list">{{ $tc("common.pef_list", 1) }}</v-tab>
        <v-tab v-if="show_tabs" href="#unassigned">{{
          $t("common.pef_list_assigned")
        }}</v-tab>
      </v-tabs>
      <v-tabs-items :value="tab">
        <v-tab-item value="list">
          <PefTable />
        </v-tab-item>
        <v-tab-item value="unassigned" v-if="show_tabs">
          <PefPcrInativeTable />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-col>
</template>

<script>
import PefTable from "@/views/pef/PefTable"
import PefPcrInativeTable from "@/views/pef/PefPcrInactiveTable.vue"

export default {
  name: "PefDiaryPage",
  components: { PefPcrInativeTable, PefTable },
  mixins: [],
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    tab: {
      set(tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get() {
        return this.$route.query.tab
      },
    },
    show_tabs() {
      return !["MENTOR", "ADMIN", "SUPERADMIN"].includes(this.current_user.role)
    },
  },

  methods: {},
}
</script>
